const copyrightSymbol = "\u00A9"; // Copyright symbol (©)
const tmSymbol = "\u2122"; // Trademark symbol (™)

export { copyrightSymbol };
export { tmSymbol };
